module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-Medium-55364adc23127eebe5d71fbc49fd4d28.woff2";